module.exports = __webpack_public_path__ + "static/media/cash-register.978e39ac.mp3";